import React from 'react';

class LandsList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
           
        };
    }

    componentDidMount = () => {
    }

  

    render() {
        return (
            <>
land
            </>
        )
    }
}

export default LandsList;

